<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
    </div>
    <div class="table-operator">
      <!-- <a-button type="primary" icon="plus" @click="handleAdd" >新建</a-button> -->
    </div>
    <template>
      <a-table ref="table"
               :columns="columns"
               rowKey="id"
               :loading="saveLoading"
               :pagination="false"
               :dataSource="treeList"
      >
        <span slot="action" slot-scope="text, record,index">
        <template >
          <a-badge :count="record.member_count">
          <a @click="handleUserList(record,index)">人员
          </a>
            </a-badge>
          <!--<a @click="handleEdit(record)">编辑</a>-->
          <!--<a-divider type="vertical" />-->
          <!--<a @click="handleAdd(record)">新增子分类</a>-->
          <!--<a-divider type="vertical" />-->
          <!--<a-popconfirm title="确定删除分类吗" @confirm="deleteCate(record)"  okText="确定" cancelText="取消">-->
          <!--<a href="javascript:;">删除</a>-->
          </a-popconfirm>
        </template>
      </span>
        <span slot="name" slot-scope="name,record">
          <span  >{{record.name}}</span>
      </span>
        <span slot="status" slot-scope="status,record">
        <a-badge status="success" v-if="status==1" text="显示" />
        <a-badge status="default" v-else text="隐藏" />
      </span>

        <span slot="rank" slot-scope="text,record">
        <template >
        <editable-cell :text="text" @change="onRankChange(record.id, 'rank', $event)"/>
        </template>
      </span>


      </a-table>
    </template>
    <a-modal
        :maskClosable="false"
            title="操作"
            :width="800"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="上级分类"
                  v-if="!formData.id"
                  hasFeedback
          >
            <a-cascader :options="options"
                        placeholder="顶级分类"
                        changeOnSelect
                        v-model="formData.parents_ids"
                        :fieldNames = "{ label: 'title', value: 'key', children: 'children' }"
            />
          </a-form-item>

          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="名称"
                  hasFeedback
          >
            <a-input v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入分类名称' }]}
        ]"
                     placeholder="请输入分类名称"/>
          </a-form-item>

          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="图标"
                  hasFeedback
          >
            <pic-uploader
                    :file-list="formData.pic"
            />
          </a-form-item>
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="状态"
                  hasFeedback
          ><r-switch  :formData="formData" field="status" :checkedValue="1" :unCheckedValue="2"  checkedChildren="显示" unCheckedChildren="隐藏" />
          </a-form-item>
          <a-form-item
                  v-if="formData.id"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="排序"
                  hasFeedback
          >
            <a-input type="number" v-decorator="[
          'rank',
          {rules: [{ required: true, message: '请输入排序' }]}
        ]"
                     placeholder="数字越小排名越靠前"/>
          </a-form-item>

        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>


    <a-modal
        :maskClosable="false"
            title="人员"
            :width="800"
            v-model="userListVisible"
            @ok="userListVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">

          <a-table :columns="userColumns" :dataSource="wyhUserList" :pagination="itemPagination" @change="handleItemTableChange" rowKey="id" :scroll="{ y: 300 }" bordered>
            <span slot="name" slot-scope="name,record">
              <img :src="record.face" style="width: 40px; vertical-align: middle;" /> {{record.name}} ({{record.phone}})
            </span>
            <template slot="action" slot-scope="text,record,index">
              <a-divider type="vertical" />
              <a-popconfirm title="确定删除此人员吗" @confirm="deleteUser(record,index)"  okText="确定" cancelText="取消">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
            <template slot="footer" slot-scope="currentPageData">
              <user-picker style="width: 200px; margin-right: 10px;" :formData="userFormData" field="user_id" />
              <a-select  style="width: 200px; margin-right: 10px;"  v-model="userFormData.type" placeholder="角色类型"  >
                <a-select-option value="管理员">管理员</a-select-option>
                <a-select-option value="工作人员">工作人员</a-select-option>
              </a-select>
              <a-button icon="plus" @click="addUser" >新增</a-button>
            </template>
          </a-table>
        </a-form>

      </a-spin>
    </a-modal>

  </a-card>
</template>

<script>
  import moment from 'moment'
  import EditableCell from '@/components/EditableCell/'
  import { getCityList,getCityUserList,addCityUser,deleteCityUser,getSubWyhList  } from '@/api/qcxjrewards'
  import PicUploader from '@/components/PicUploader/'
  import RSwitch from '@/components/RSwitch/'
  import UserPicker from '@/components/UserPicker/'
  export default {
    name: 'CityList',
    components: {
      PicUploader,EditableCell,RSwitch,UserPicker
    },
    data () {
      return {
        userListVisible:false,
        saveLoading:false,
        visible: false,
//        description: '全校班级管理。',
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        itemPagination:{
          total:0
        },
        itemQuery:{
          // goods_id:0,
          // status:0,
          page:1,
          keywords:undefined
        },

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
        },
        userFormData:{
          user_id:undefined,
          type: undefined,
        },

        //人员管理表头
        userColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '80px'
          },
          {
            title: '用户名',
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' },
          },
          {
            title: '角色',
            width:'100px',
            dataIndex: 'role_type',
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: '150px',
            scopedSlots: { customRender: 'action' },
          }
        ],
        wyhUserList:[],
        // 表头
        columns: [
          {
            title: '名称',
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' },
          },/*
           {
           title: '状态',
           dataIndex: 'status',
           scopedSlots: { customRender: 'status' },
           },
           {
           title: '排序',
           dataIndex: 'rank',
           scopedSlots: { customRender: 'rank' },
           },*/
          {
            table: '操作',
            dataIndex: 'action',
            width: '250px',
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
        },
        treeList:[

        ],
        cateList:[

        ],
        formData:{
          name:'',
          parents_ids:[],
          id:0,
          pic:[],
          status:1,
        },
        selectedRowKeys: [],
        selectedRows: [],
      }
    },
    created () {
//      getRoleList({ t: new Date()})
    },
    computed:{
      options (){
        return  this.treeList;
      }
    },
    mounted(){
      let that = this;
      that.fetch();
    },
    methods: {
      fetch(){
        let that = this;
        that.saveLoading =true;
        getCityList()
                .then(res => {
                  that.treeList =  res.data
                  that.saveLoading =false;
                })
      },
      handleCancel(){
        this.visible = false
      },
      // 增
      handleAdd(record) {
        let that = this;
        that.visible = true;
        that.form.resetFields();
        console.log('handleAdd');
        that.formData = {
          name:'',
          parents_ids:[],
          id:0,
          pic:[],
          status:1,
        }
        if(record.id){
          that.formData.parents_ids = that.cateParentsIds(record.id);
          that.formData.parents_ids.push(record.id);
        }
        setTimeout( () =>{
          that.form.setFieldsValue({ ...that.formData });
        });
      },
      // 改
      handleEdit(record) {
        let self = this
        this.visible = true
//      this.form.resetFields();
        self.form.setFieldsValue({
          name:'',
          rank:0,
        });
        this.formData.id = record.id;
        getCateDetail({ id: record.id }).then(res => {
          setTimeout(()=>{
            self.form.setFieldsValue({...res.data});
          },1)
          self.formData.name = res.data.name;
          self.formData.pic = res.data.pic;
          self.formData.parents_ids = self.cateParentsIds(record.id);
          self.formData.status = res.data.status;
        })
        // console.log(this.mdl)
      },
      // 增改 处理
      handleOk(e) {
        let self = this
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            if(self.formData.id) {
              editCate(Object.assign(self.formData,values)).then(res => {
                self.$message.success('修改成功')
                self.fetch();
                self.visible = false;
                self.saveLoading = false;
              }).catch(err =>{
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }else{
              addCate(Object.assign(self.formData,values)).then(res => {
                self.$message.success('新增成功')
                self.fetch();
                self.visible = false
                self.saveLoading = false;
              }).catch(err =>{
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }
          }
        })
      },
      handleUserList(record,index){
        this.userListVisible = true;
        this.userFormData.city_id = record.id;
        this.userFormData.weiyuanhui_index = index
        this.itemQuery.page = 1;
        this.fetchUser();
      },

      handleItemTableChange(pagination, filters, sorter) {
        console.log('filters',filters);
        let that = this;
        // if(filters.status){
        //   that.itemQuery.status = filters.status[0];
        // }else{
        //   that.itemQuery.status = 0;
        // }
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        that.pagination = pager;
        that.itemQuery.page = pagination.current;
        that.fetchUser();
      },

      fetchUser(){
        let that = this;
        that.itemQuery.city_id = that.userFormData.city_id

        getCityUserList(Object.assign(that.itemQuery,that.itemPagination)).then(res => {
          that.wyhUserList = res.data.list
          that.itemPagination.total = res.data.total
        })

      },
      addUser(){
        let self = this;
        if(!self.userFormData.user_id){
          self.$message.error('请选择人员');
          return ;
        }
        if(!self.userFormData.type){
          self.$message.error('请选择类型');
          return ;
        }
        console.log(self.userFormData)

        addCityUser(self.userFormData).then(res => {
          self.userFormData.user_id = undefined;
          self.userFormData.type = undefined;
          self.$message.success('新增成功')
          self.fetchUser();
          self.treeList[self.userFormData.weiyuanhui_index].member_count++;
        }).catch(err =>{
          self.$message.error(err.data.msg);
        })
      },
      deleteUser(record,index){
        let self = this;
        deleteCityUser({
          user_id:record.user_id,
          city_id:self.userFormData.city_id,
        }).then(res => {
          self.$message.success('删除成功')
          self.wyhUserList.splice(index,1);
          self.treeList[self.userFormData.weiyuanhui_index].member_count--;
        }).catch(err =>{
          self.$message.error(err.data.msg);
        })
      },

    },
    watch: {
      /*
       'selectedRows': function (selectedRows) {
       this.needTotalList = this.needTotalList.map(item => {
       return {
       ...item,
       total: selectedRows.reduce( (sum, val) => {
       return sum + val[item.dataIndex]
       }, 0)
       }
       })
       }
       */
    }
  }
</script>
